import React from 'react';
import { TextInput, Button, Group, Box, Grid, Select } from '@mantine/core';
import { DatePicker } from '@mantine/dates';
import { useForm } from '@mantine/form';
import { IUser } from "../../../api/User/User.types";
import LoaderDefault from "../../common/Loader.default/Loader.default";

interface Props {
  onSubmitQuery?: (query: any) => void,
  initialValues?: any,
  user?: IUser
}

interface FormValues {
  ConsigneeId: string,
  DateTo: any,
  DateFrom: any
}

function WidgetFilters({ onSubmitQuery, initialValues, user }: Props) {
  const form = useForm<FormValues>({
    initialValues: Object.keys(initialValues).length === 0 ? {
      ConsigneeId: user?.defaultConsignee?.entityID,
      DateTo: "",
      DateFrom: new Date(new Date().setFullYear(new Date().getFullYear() - 1))
    } : initialValues,
    validate: {
      DateTo: (value, values) => {
        if (!value) return null;
        return value.getTime() < values.DateFrom.getTime() ? 'Date To must be later than Date From' : null
      }
    },
  });
  function onSubmit(values: typeof form.values) {
    if (onSubmitQuery) {
      onSubmitQuery(values)
    }
  }

  if (!user || !user.consignees) {
    return <LoaderDefault text="Loading User..." />
  }

  if (Object.keys(initialValues).length === 0) {
    onSubmit(form.values);
  }

  return (
    <div className='widget-filters'>
      <Box mx="auto">
        <form onSubmit={form.onSubmit(onSubmit)}>
          <Grid>
            <Grid.Col sm={6} lg={4}>
              <Select
                data={user?.consignees?.map(sh => ({ value: sh.entityID, label: sh.entityName }))}
                required
                placeholder="Consignee Name"
                label="Name"
                {...form.getInputProps('ConsigneeId')}
              />
            </Grid.Col>
            <Grid.Col sm={6} lg={4}>
              <DatePicker
                label="Date From"
                placeholder="Date From"
                {...form.getInputProps('DateFrom')}
              />
            </Grid.Col>
            <Grid.Col sm={6} lg={4}>
              <DatePicker
                label="Date To"
                placeholder="Date To"
                {...form.getInputProps('DateTo')}
              />
            </Grid.Col>
          </Grid>
          <Group position="right" mt="md">
            <Button type="submit">Submit</Button>
          </Group>
        </form>
      </Box>
    </div>
  )
}

export default WidgetFilters;
